import { useSelector } from 'react-redux';

export const useFeatureAccess = () => {
    const { subscription } = useSelector((state) => state.payment);
    const { totalAnalyses } = useSelector((state) => state.analysis);
    const hasActiveSubscription = subscription?.status === 'active';

    // Grant Pro access if user has an active subscription OR if they are on their first property
    // This allows free users to experience full features for their initial property analysis.
    const hasProAccess = hasActiveSubscription || totalAnalyses <= 1;

    // Set search limit based on plan
    let searchLimit = 2; // Default Free tier allows 2 searches
    if (hasActiveSubscription) {
        const planName = subscription.plan?.name || '';
        if (planName.startsWith('Professional')) {
            searchLimit = 50;
        } else if (planName.startsWith('Standard')) {
            searchLimit = 5;
        } else if (planName.toLowerCase().includes('single')) {
            searchLimit = 1; // Single Use plan allows exactly 1 property analysis
        } else {
            // Fallback for any other active plans
            searchLimit = Infinity;
        }
    }

    return {
        hasPro: hasProAccess,
        canExport: hasProAccess,
        canViewContours: hasProAccess,
        canViewMap: hasProAccess,
        canSaveHistory: hasProAccess,
        searchLimit: searchLimit
    };
};

export default useFeatureAccess;

